import React from 'react';
import Axios from 'axios';
import moment from 'moment';

const cstTableHeaders = [
  ['#', 'Joueur', 'Équipe', 'Rang', 'Sondé', 'Moy', 'Gap Moy.', 'Score', 'Comité', 'Trophée EL'],
  ['#', 'Date/Heure', 'Répondant', 'Équipe', 'Division', 'Tel', 'Score'],
  ['#', 'Joueur', 'Équipe', 'Comité', 'Trophée EL', 'Form.']
];
const cstDefaultSortFieldIdx = [5, 1, 3];
const cstDefaultSortOrder = [
  ['', 'asc', 'asc', 'asc', 'asc', 'asc', 'asc', 'desc', 'desc', 'desc'],
  ['', 'asc', 'asc', 'asc', 'asc', 'asc', 'desc'],
  ['', 'asc', 'asc', 'desc', 'desc', 'desc']
];
const cstFixedDecimalsStats = [
[
  {fieldIdx: 5, decimals: 2},
  {fieldIdx: 6, decimals: 2},
], 
[
  {fieldIdx: 6, decimals: 2},
], 
[]
];

const TBL0_CMT_COL = 8;
const TBL0_ELT_COL = 9;
const TBL2_CMT_COL = 3;
const TBL2_ELT_COL = 4;

class RateSysAdminList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      rateSysCommitteeVotesOption: false,
      rateSysElTrophyVotesOption: false,
      rateSysShowAdvancedStatsOption: false,
      rateSysPlayers: [],
      playersByDivision: true,

      sDataTable: [[], [], []],
      sSortFieldIdx: [
        cstDefaultSortFieldIdx[0],
        cstDefaultSortFieldIdx[1],
        cstDefaultSortFieldIdx[2]
      ],
      sSortOrder: [
        cstDefaultSortOrder[0][cstDefaultSortFieldIdx[0]],
        cstDefaultSortOrder[1][cstDefaultSortFieldIdx[1]],
        cstDefaultSortOrder[2][cstDefaultSortFieldIdx[2]]
      ],
      loading: [true, true, true]
    };

    this.handleDivisionChange = this.handleDivisionChange.bind(this);
    this.dispDataTable = this.dispDataTable.bind(this);
    this.createTableHdrRow = this.createTableHdrRow.bind(this);
    this.createDataRow = this.createDataRow.bind(this);
    this.createDataCell = this.createDataCell.bind(this);
    this.sortdataTable = this.sortdataTable.bind(this);
  }

  componentDidMount() {
    //console.log('RateSysAdminList: componentDidMount');
    if (this.props.season._id !== undefined) {
      this.loadData()
    }
  }

  componentDidUpdate(prevProps) {
    //console.log('RateSysAdminList: componentDidUpdate')
    if (prevProps.season._id.toString() !== this.props.season._id) {
      this.loadData()
    }
  }

  loadData() {
    var seasonId = this.props.season._id;
    Axios.get('/api/ratesys/getRateSys/global/' + seasonId).then(responseRateSys => {
      var rateSys = responseRateSys.data;
      var playersByDivision = rateSys.playersByDivision;

      this.loadFiltData(rateSys.players, playersByDivision, 0);

      this.setState({
        rateSysCommitteeVotesOption: rateSys.committeeVotes,
        rateSysElTrophyVotesOption: rateSys.elTrophyVotes,
        rateSysShowAdvancedStatsOption: rateSys.showAdvancedStats,
        rateSysPlayers: rateSys.players,
        playersByDivision: playersByDivision,
      });
    });
  }

  loadFiltData(rateSysPlayers, playersByDivision, divIdx) {
    var season = this.props.season;
    var seasonId = this.props.season._id;

    // Get division name, if using divisions
    var division = season.subSeasons[0].divisions[divIdx].name; 
    if (!playersByDivision || (season.subSeasons[0].divisions.length <= 1)) {
      division = "ALL";
    }

    var URLdivision = encodeURIComponent(division.replace(/\./g, ' '));

    Axios.get('/api/ratesys/entries/' + seasonId + '/division/' + URLdivision).then(responseRateSysEntries => {
    Axios.get('/api/ratesys/respondents/' + seasonId + '/division/' + URLdivision).then(responseRateSysRespondents => {

      var rateSysEntries = responseRateSysEntries.data;
      var rateSysRespondents = responseRateSysRespondents.data;

      rateSysPlayers = rateSysPlayers.filter(rsp => ((division === "ALL") || (rsp.teamDiv === division)));
      rateSysPlayers.forEach(rsp => {
        rsp.form = 0;
        rateSysRespondents.forEach(rsr => {
          if (rsp._id.toString() === rsr.playerId.toString()) {
            rsp.form +=1;
          }
        });
      });

      this.createDataTable(0, rateSysEntries);
      this.createDataTable(1, rateSysRespondents);
      this.createDataTable(2, rateSysPlayers);
    });
    });
  }

  createDataTable(tableIdx, dataResults) {
    // Parse results
    var dataTable = [];
    dataResults.forEach(function(result, resultIdx) {

      var dataTableRow = [];

      switch(tableIdx) {
      case 0: 
        dataTableRow.push(0);
        dataTableRow.push(result.playerFullname);
        dataTableRow.push(result.playerTeam);
        dataTableRow.push(result.playerRank);
        dataTableRow.push(result.respondentFullname);
        dataTableRow.push(result.calcAvgRankFilt);
        dataTableRow.push(result.calcAvgRankGap);
        dataTableRow.push(result.entryRatingScore);
        dataTableRow.push(result.committeeVotes);
        dataTableRow.push(result.elTrophyVotes);
        break;

      case 1: 
        var playerTeamDiv = (result.playerTeamDiv === "") ? "N/A" : result.playerTeamDiv;
        dataTableRow.push(0);
        dataTableRow.push(moment(result.dateCreation).local().format("YYYY-MM-DD HH:mm:ss"));
        dataTableRow.push(result.fn);
        dataTableRow.push(result.playerTeam);
        dataTableRow.push(playerTeamDiv);
        dataTableRow.push(result.tel);
        dataTableRow.push(result.ratingScore);
        break;

      case 2: 
        dataTableRow.push(0);
        dataTableRow.push(result.fn);
        dataTableRow.push(result.team);
        dataTableRow.push(result.committeeVotes);
        dataTableRow.push(result.elTrophyVotes);
        dataTableRow.push(result.form);
        break;
      }

      // Build table
      dataTable.push(dataTableRow.slice());
    });

    // First data sort
    var sortFieldIdx = this.state.sSortFieldIdx[tableIdx];
    var sortOrder = this.state.sSortOrder[tableIdx];
    this.sortdataTable(tableIdx, dataTable, sortFieldIdx, sortOrder);
  }

  sortdataTable(tableIdx, dataTable, sortFieldIdx, sortOrder) {
    var sDataTable = this.state.sDataTable;
    var sSortFieldIdx = this.state.sSortFieldIdx;
    var sSortOrder = this.state.sSortOrder;

    // Manage empty data
    if (dataTable.length !== 0) {

      var sortSign = 1;
      if (sortOrder === 'desc') { 
        sortSign = -1; 
      }

      dataTable.sort(function(a, b) {
        var valueA = a[sortFieldIdx];
        var valueB = b[sortFieldIdx];
        var compVal = 0;

        switch(typeof a[sortFieldIdx]) {
          case "date":
            compVal = new Date(valueA) - new Date(valueB);
            break;
          case "string":
            compVal = valueA.localeCompare(valueB);
            break;
          case "number":
            compVal = valueA - valueB;
            break;
          default:
            break;
        }

        if (compVal !== 0) {
          return (sortSign * compVal);
        } else {

          switch(tableIdx) {
          case 0: 
            compVal = a[3] - b[3];
            break;
          case 1: 
            compVal = new Date(b[1]) - new Date(a[1]);
            break;
          case 2: 
            compVal = a[1].localeCompare(b[1]);
            break;
          }
          return compVal;
        }
      });
    }

    dataTable.forEach((dataRow, dataRowIdx, dataTable) => {
      dataTable[dataRowIdx][0] = dataRowIdx + 1;
    });

    sDataTable[tableIdx] = dataTable;
    sSortFieldIdx[tableIdx] = sortFieldIdx;
    sSortOrder[tableIdx] = sortOrder;

    var loading = this.state.loading;
    loading[tableIdx] = false;

    this.setState({
      sDataTable: sDataTable,
      sSortFieldIdx: sSortFieldIdx,
      sSortOrder: sSortOrder,
      loading: loading
    });

  }

  render() {
    // console.log('RateSysAdminList: render');
    // console.log(this.state);
    var loading = false;
    this.state.loading.forEach(ld => {
      loading = loading || ld;
    });

    return (
      <div>
      {loading ? this.displaySpinner() : this.displayData()}
      </div>
    );
  }

  displayData() {
    return (
      <div>
        {this.showDivisionsSelector()}

        {/* SUMMARY */}
        <div className="row">
        <div className="col-12">
          <h5>Sommaire</h5>
          <ul>
            <li>Nombre d'entrées: {this.state.sDataTable[0].length}</li>
            <li>Nombre de formulaires soumis: {this.state.sDataTable[1].length}</li>
            <li>Nombre de joueurs: {this.state.sDataTable[2].length}</li>
          </ul>
        </div>
        </div>

        <hr className="hr-nomargin-top"/>

        {/* TABLE 1 */}
        <div className="row row-margin-bottom-50">
        <div className="col-xl-10 col-12">
          <h5>Formulaires soumis</h5>
          {this.dispDataTable(1)}
        </div>
        </div>
        <hr className="hrThick"/>

        {/* TABLE 0 */}
        {this.state.rateSysShowAdvancedStatsOption ?
          <React.Fragment>
          <div className="row row-margin-bottom-50">
          <div className="col-12">
            <h5>Entrées</h5>
            {this.dispDataTable(0)}
          </div>
          </div>
          <hr className="hrThick"/>
          </React.Fragment>
          : null}

        {/* TABLE 2 */}
        {this.state.rateSysShowAdvancedStatsOption ?
          <div className="row row-margin-bottom-50">
          <div className="col-xl-7 col-12">
            <h5>Compilation (votes et formulaires)</h5>
            {this.dispDataTable(2)}
          </div>
          </div>
          : null}

      </div>
    )
  }

  showDivisionsSelector() {
    if (!this.state.playersByDivision) {
      return;
    }

    var divisions = [];
    if (this.props.season.subSeasons != undefined) {
      divisions = this.props.season.subSeasons[0].divisions;
    }

     return (
      <div className="row row-margin-bottom-20">
      <div className="col-4">
        <h6>Cotation de joueurs par division</h6>
        <span>Choisir une division</span>
        <select className="form-control"
          value={this.state.selectedDivIdx} onChange={this.handleDivisionChange}>
          {divisions.map(this.dispDivOptions)}
        </select>
      </div>
      </div>
    );
  }
  
  dispDivOptions(div, divIdx, divisions) {
    return (
      <option value={divIdx} key={'div.'+ divIdx}>{div.name}</option>
    )
  }

  handleDivisionChange(e) {
    var selectedDivisionIdx = parseInt(e.target.value, 10);
    this.setState({ loading: [true, true, true] });
    this.loadFiltData(this.state.rateSysPlayers, this.state.playersByDivision, selectedDivisionIdx)
  }

  dispDataTable(tableIdx) {
    var dataTable = this.state.sDataTable[tableIdx];
    return (
      <div className="row">
      <div className="col-12">

        <div className="table-responsive tableFixHeader tableFixHeaderRateSys resizeVerticalRateSys">
        <table className="table table-sm table-ratesysForm rateSysResultsTableHover tableFix2col">
          <thead><tr>
            {cstTableHeaders[tableIdx].map(this.createTableHdrRow.bind(this, tableIdx))}
          </tr></thead>
          <tbody>
            {dataTable.length !== 0 ? 
              dataTable.map(this.createDataRow.bind(this, tableIdx)) : 
              <tr><td colSpan='99'> Aucune entrée </td></tr> }
          </tbody>
        </table>
        </div>

      </div>
      </div>
    )
  }

  createTableHdrRow(tableIdx, hdrItem, hdrIdx) {
    var classNameStr = '';
    var onClickAction = function() {};

    // Disabled sections ?
    if ( ((tableIdx === 0) && (hdrIdx === TBL0_CMT_COL) && (!this.state.rateSysCommitteeVotesOption)) ||
         ((tableIdx === 0) && (hdrIdx === TBL0_ELT_COL) && (!this.state.rateSysElTrophyVotesOption)) ) {
      return;
    }
    if ( ((tableIdx === 2) && (hdrIdx === TBL2_CMT_COL) && (!this.state.rateSysCommitteeVotesOption)) ||
         ((tableIdx === 2) && (hdrIdx === TBL2_ELT_COL) && (!this.state.rateSysElTrophyVotesOption)) ) {
      return;
    }

    // Sort with arrows
    if (hdrIdx !== 0) {
      onClickAction = this.handleSortTable.bind(this, tableIdx);
      classNameStr = 'statelo-sorting';
      if(hdrIdx === this.state.sSortFieldIdx[tableIdx]) {
        if (this.state.sSortOrder[tableIdx] === "asc") {
          classNameStr += ' statelo-sorting_asc';
        } else {
          classNameStr += ' statelo-sorting_desc';
        }
      }
    }

    return (
      <th key={"colid." + tableIdx + '.' + hdrIdx}
        id={"colid." + tableIdx + '.' + hdrIdx} 
        className={classNameStr}
        onClick={onClickAction}>
        {hdrItem}
      </th>
    );
  }

  createDataRow(tableIdx, dataRow, dataRowIdx) {
    return (
      <tr key={'te.' + dataRowIdx}>
        {dataRow.map(this.createDataCell.bind(this, tableIdx))}
      </tr>
    );
  }

  createDataCell(tableIdx, dataCell, dataCellIdx) {
    // Disabled sections ?
    if ( ((tableIdx === 0) && (dataCellIdx === TBL0_CMT_COL) && (!this.state.rateSysCommitteeVotesOption)) ||
         ((tableIdx === 0) && (dataCellIdx === TBL0_ELT_COL) && (!this.state.rateSysElTrophyVotesOption)) ) {
      return;
    }
    if ( ((tableIdx === 2) && (dataCellIdx === TBL2_CMT_COL) && (!this.state.rateSysCommitteeVotesOption)) ||
         ((tableIdx === 2) && (dataCellIdx === TBL2_ELT_COL) && (!this.state.rateSysElTrophyVotesOption)) ) {
      return;
    }

    // Fixed number of decimals, converting to string, for averages or any other stats
    cstFixedDecimalsStats[tableIdx].forEach(function(fdItem, fdIOdx) {
      if (dataCellIdx === fdItem.fieldIdx) {
        dataCell = dataCell.toFixed(fdItem.decimals);
      }
    })

    return (
      <td key={"tdcell." + dataCellIdx}>{dataCell}</td>
    );
  }

 
  handleSortTable(tableIdx, e) {
    var sortFieldIdx = parseInt(e.target.id.split(".")[2], 10);
    var dataTable = this.state.sDataTable[tableIdx];
    var sortOrder = this.state.sSortOrder[tableIdx];
    var prevSortFieldIdx = this.state.sSortFieldIdx[tableIdx];

    // Toggle sort order
    if (prevSortFieldIdx === sortFieldIdx) {
      if (sortOrder === 'asc') {
        sortOrder = 'desc';
      } else {
        sortOrder = 'asc';
      }
    } else {
      sortOrder = cstDefaultSortOrder[tableIdx][sortFieldIdx];
    }

    this.sortdataTable(tableIdx, dataTable, sortFieldIdx, sortOrder);
  }

  displaySpinner() {
    return (
      <div className="sk-three-bounce">
        <div className="sk-child sk-bounce1"></div>
        <div className="sk-child sk-bounce2"></div>
        <div className="sk-child sk-bounce3"></div>
      </div>
    );
  }

}

export default RateSysAdminList;